var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 20.691,
    y: 80.52,
    width: 459.08,
    height: 319.48,
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40
    },
    d: "M 18.937 79.328 C 18.937 79.328 199.996 275.77 253.488 275.77 C 308.506 275.77 481.356 80.556 481.356 80.556"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40
    },
    x1: 18.272,
    y1: 402.916,
    x2: 183.362,
    y2: 237.826
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      stroke: "rgb(0, 255, 0)",
      strokeWidth: 40
    },
    x1: 483.389,
    y1: 405.408,
    x2: 317.148,
    y2: 239.167
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/emailLogo.05d27bf8fda52cd3e970ea81f4ee1090.svg";
export { ForwardRef as ReactComponent };